import Post from "../post/Post";
import Share from "../share/Share";
import "./Feed.css";
import { useState, useEffect, useContext } from "react";
import axiosInstance from '../../config';
import SocialContext from "../../context/SocialContext";
import { Link } from "react-router-dom";
import Progress from "../Progress/Progress";

export default function Feed(props) {
  const { user } = useContext(SocialContext);
  const [posts, setposts] = useState([]);
  const [fetchagain, setfetchagain] = useState(false);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    const fetchPosts = async () => {
      setloading(true);
      const response = props.user ? await axiosInstance.get(`/api/posts/profile/${props.user}`) : await axiosInstance.get(`/api/posts/timeline/${user._id}`);
      setposts(response.data.sort((p1, p2) => {
        return new Date(p2.createdAt) - new Date(p1.createdAt);
      }));
      setloading(false);
    }
    fetchPosts();
  }, [user, props.user, fetchagain])

  // useEffect(() => {
  //   window.document.title='Home | Welcome '+user.username;
  // }, [])
  

  return (
    <div className="feed">
      <div className="feedWrapper">
        {loading ?'':<Share />}
        {loading ? <div style={{'minHeight':'100vh',display:'flex','alignItems':'center','justifyContent':'center'}}><Progress /></div> : ''}
        {posts.map((p) => (
          <Post key={p._id} post={p} setfetchagain={setfetchagain} />
        ))}

      </div>
    </div>
  );
}